<template>
  <section class="tz-band">
    <div class="tz-card">
      <div class="tz-head">
        <div class="tz-eyebrow">ANYONE CAN START ONE</div>
        <div class="tz-word">TRIBZZ</div>
        <div class="tz-rule"><span></span><em>◆ YOU CREATE THE CULTURE ◆</em><span></span></div>
      </div>

      <div class="tz-body">
        <div class="tz-copy">
          <div class="tz-kicker">OUR SISTER PLATFORM</div>
          <h2 class="tz-title">Give your pest control company a Tribzz.</h2>
          <p class="tz-text">
            ExtermiCloud runs the jobs. Tribzz is where your customers and your neighbourhood follow you.
            Collect job requests, send quotes, post seasonal alerts, run polls and go live. It's social media
            for grown-ups, with no ads and no data sold.
          </p>
          <div class="tz-tags">
            <span v-for="t in tags" :key="t">{{ t }}</span>
          </div>
          <div class="tz-actions">
            <router-link to="/tribzz" class="tz-btn tz-btn--dark">SEE WHAT IT DOES →</router-link>
            <a v-if="start.href" :href="start.href" target="_blank" rel="noopener" class="tz-btn tz-btn--ghost">START YOUR TRIBZZ</a>
            <router-link v-else :to="start.to" class="tz-btn tz-btn--ghost">START YOUR TRIBZZ</router-link>
          </div>
        </div>

        <div class="tz-preview" aria-hidden="true">
          <div class="tz-post">
            <div class="tz-post__top">
              <span class="tz-avatar">S</span>
              <div>
                <strong>SentryPest</strong>
                <small>Your trade or service · Announcement</small>
              </div>
            </div>
            <p class="tz-post__quote">“Mosquito season starts this week. Book your yard treatment before the first big hatch.”</p>
            <div class="tz-poll">
              <div class="tz-poll__q">What are you seeing this week?</div>
              <div class="tz-poll__row"><span style="width: 58%"></span><em>Ants · 58%</em></div>
              <div class="tz-poll__row"><span style="width: 27%"></span><em>Mosquitoes · 27%</em></div>
              <div class="tz-poll__row"><span style="width: 15%"></span><em>Wasps · 15%</em></div>
            </div>
            <div class="tz-post__foot">
              <span>QUOTES</span><span>DEALS</span><span>LIVE</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { tribzzStartLink } from "@/config/tribzz";

export default {
  name: "TribzzPromo",
  data() {
    return {
      tags: ["QUOTES", "ANNOUNCEMENTS", "POLLS", "EVENTS", "LIVE", "DEALS", "NO ADS"],
      start: tribzzStartLink(),
    };
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;800;900&family=Lora:ital,wght@0,400;0,600;1,400&family=IBM+Plex+Mono:wght@500&display=swap");

.tz-band {
  padding: 40px 16px 90px;
  background: #06090a;
}
.tz-card {
  max-width: 1120px;
  margin: 0 auto;
  border-radius: 6px;
  overflow: hidden;
  background: #f3eee6;
  color: #1b1714;
  box-shadow: 0 30px 80px -40px rgba(0, 0, 0, 0.9);
}
.tz-head {
  background: #1b1714;
  color: #f3eee6;
  text-align: center;
  padding: 30px 20px 22px;
  border-bottom: 4px solid #a8322b;
}
.tz-eyebrow,
.tz-kicker,
.tz-rule em,
.tz-tags span,
.tz-btn,
.tz-post__foot span {
  font-family: "IBM Plex Mono", ui-monospace, monospace;
  letter-spacing: 0.28em;
  font-size: 11px;
  font-style: normal;
}
.tz-word {
  font-family: "Playfair Display", Georgia, serif;
  font-weight: 900;
  font-size: clamp(44px, 7vw, 68px);
  letter-spacing: 0.06em;
  line-height: 1.1;
  margin: 6px 0 8px;
}
.tz-rule {
  display: flex;
  align-items: center;
  gap: 16px;
  max-width: 760px;
  margin: 0 auto;
}
.tz-rule span {
  flex: 1;
  height: 1px;
  background: rgba(243, 238, 230, 0.35);
}
.tz-rule em {
  color: #c9a64b;
  white-space: nowrap;
}
.tz-body {
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 40px;
  padding: 44px 44px 48px;
  align-items: center;
}
.tz-kicker {
  color: #a8322b;
  margin-bottom: 12px;
}
.tz-title {
  font-family: "Playfair Display", Georgia, serif !important;
  font-weight: 800 !important;
  font-size: clamp(28px, 3.4vw, 40px);
  line-height: 1.15;
  letter-spacing: 0 !important;
  margin: 0 0 14px;
  color: #1b1714;
}
.tz-text {
  font-family: "Lora", Georgia, serif;
  font-size: 17px;
  line-height: 1.65;
  color: #3d342d;
  margin: 0 0 18px;
}
.tz-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 26px;
}
.tz-tags span {
  border: 1px solid #1b1714;
  padding: 5px 9px;
  font-size: 10px;
  letter-spacing: 0.16em;
}
.tz-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.tz-btn {
  display: inline-block;
  padding: 14px 20px;
  text-decoration: none;
  font-weight: 500;
  letter-spacing: 0.18em;
  transition: transform 0.15s ease;
}
.tz-btn:hover {
  transform: translateY(-1px);
}
.tz-btn--dark {
  background: #1b1714;
  color: #f3eee6 !important;
  box-shadow: 4px 4px 0 #c9a64b;
}
.tz-btn--ghost {
  border: 1px solid #1b1714;
  color: #1b1714 !important;
}
.tz-post {
  background: #fbf8f3;
  border: 1px solid #ddd3c4;
  padding: 22px;
  box-shadow: 8px 8px 0 #1b1714;
}
.tz-post__top {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-bottom: 12px;
}
.tz-post__top strong {
  display: block;
  font-family: "Playfair Display", Georgia, serif;
  font-size: 18px;
}
.tz-post__top small {
  font-family: "Lora", Georgia, serif;
  font-style: italic;
  color: #6d6158;
}
.tz-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #1b1714;
  color: #f3eee6;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Playfair Display", Georgia, serif;
  font-weight: 800;
}
.tz-post__quote {
  font-family: "Lora", Georgia, serif;
  font-style: italic;
  font-size: 16px;
  border-left: 3px solid #c9a64b;
  padding-left: 12px;
  margin: 0 0 16px;
  color: #3d342d;
}
.tz-poll__q {
  font-family: "Lora", Georgia, serif;
  font-weight: 600;
  margin-bottom: 8px;
}
.tz-poll__row {
  position: relative;
  height: 30px;
  border: 1px solid #ddd3c4;
  margin-bottom: 6px;
  background: #f3eee6;
}
.tz-poll__row span {
  position: absolute;
  inset: 0 auto 0 0;
  background: rgba(168, 50, 43, 0.16);
}
.tz-poll__row em {
  position: relative;
  font-family: "Lora", Georgia, serif;
  font-style: normal;
  font-size: 13px;
  line-height: 30px;
  padding-left: 10px;
}
.tz-post__foot {
  display: flex;
  gap: 8px;
  margin-top: 14px;
}
.tz-post__foot span {
  border: 1px solid #1b1714;
  padding: 4px 8px;
  font-size: 9.5px;
  letter-spacing: 0.14em;
}
@media (max-width: 860px) {
  .tz-body {
    grid-template-columns: 1fr;
    padding: 30px 22px 34px;
    gap: 28px;
  }
}
</style>
